import React from "react";
import PropTypes from "prop-types";

import SavedSearchSelect from "../containers/saved_search_select";

class Root extends React.Component {
  render () {
    const disableSave = this.props.disableSaveSearchButton;
    const disableDownload = this.props.disableDownloadButton;
    const onSaveClick = disableSave ? () => {} : this.props.onSaveSearchClick;
    const onDownloadClick = this.props.searchSelected ? this.props.downloadLoadedSearch : this.props.onDownloadClick;
    return (
      <div className="col-md-12 form-group saved-search-box">
        <div className="row">
          <SavedSearchSelect />
        </div>
        <div className="row">
          <div className="col-md-12 controls">
            <a onClick={onSaveClick} disabled={disableSave} className="btn btn-block btn-primary">Save search</a>
            <a onClick={onDownloadClick} disabled={disableDownload} className="btn btn-block btn-primary">Download</a>
          </div>
        </div>
      </div>
    );
  }
}

Root.propTypes = {
  disableSaveSearchButton: PropTypes.bool.isRequired,
  disableDownloadButton: PropTypes.bool.isRequired,
  searchSelected: PropTypes.bool.isRequired,
  onSaveSearchClick: PropTypes.func.isRequired,
  onDownloadClick: PropTypes.func.isRequired,
  downloadLoadedSearch: PropTypes.func.isRequired
};

export default Root;
